export default __webpack_public_path__ + "static/media/background.368f89d1.jpg";